export const EX_ID = 1
export const EW_ID = 2
export const CR_ID = 3
export const EN_ID = 4
export const VU_ID = 5
export const LR_ID = 6
export const NT_ID = 7
export const LC_ID = 8
export const DD_ID = 9

export const redListCategory = [
  { name: 'EX', id: EX_ID },
  { name: 'EW', id: EW_ID },
  { name: 'CR', id: CR_ID },
  { name: 'EN', id: EN_ID },
  { name: 'VU', id: VU_ID },
  { name: 'LR', id: LR_ID },
  { name: 'NT', id: NT_ID },
  { name: 'LC', id: LC_ID },
  { name: 'DD', id: DD_ID }
]
